import { compose } from '@reduxjs/toolkit';
import { withTranslation } from 'react-i18next';
import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'store/rootReducer';
import { hideConfirmation } from 'store/alert/actions';
import { AlertStateProps } from './Alert.types';
import Alert from './Alert.layout';


const mapStateToProps = (state:RootState): AlertStateProps => ({ ...state.alert });
const mapDispatchToProps = (dispatch) => ({ dispatchHide: () => dispatch(hideConfirmation()) });

const decorate = compose < ComponentType >(
    withTranslation('common'),
    connect(mapStateToProps, mapDispatchToProps),
);

export default decorate(Alert);
